<script setup>

    import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
    import { EllipsisVerticalIcon } from '@heroicons/vue/20/solid'

    const props = defineProps({
        links: {},
        direction: {
            type: String,
            default: 'left'
        }
    })

</script>

<template>
    <Menu
        as="div"
        class="relative inline-block text-left"
    >
        <div>
            <MenuButton
                class="flex items-center rounded-md p-2 text-zinc-400 hover:text-zinc-600 focus:outline-none focus:ring-2 focus:ring-lifeworx-blue-600 focus:ring-offset-2 focus:ring-offset-zinc-100"
            >
                <span class="sr-only">Open</span>
                <slot name="button">
                    <EllipsisVerticalIcon class="h-5 w-5" aria-hidden="true" />
                </slot>
            </MenuButton>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems
                class="absolute z-popover mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                :class="{
                    'right-0' : props.direction == 'left',
                    'left-0' : props.direction == 'right',
                }"
            >
                <div class="py-1 w-fit whitespace-nowrap">
                    <MenuItem
                        v-for="link in props.links"
                        v-slot="{ active }"
                    >
                        <a
                            :href="link.href"
                            :class="[active ? 'bg-zinc-100 text-lifeworx-blue-600' : 'text-zinc-700', 'block px-4 py-2 text-base font-semibold']"
                        >
                            {{ link.label }}
                        </a>
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>
